import styled from 'styled-components';

import Chip from '@material-ui/core/Chip';

import { dangerColor, infoColor, neutralColor, successColor, warnColor } from '../../../lib/theme';
import { StatusTone } from './status-chip.types';

// Tone → {fill, text}. Pending uses near-black text on the yellow fill; white on
// warnColor is ~1.3:1 — illegible (see CLAUDE.md "Colour & contrast").
const TONE_STYLE: Record<StatusTone, { bg: string; fg: string }> = {
  success: { bg: successColor, fg: '#fff' },
  info: { bg: infoColor, fg: '#fff' },
  pending: { bg: warnColor, fg: 'rgba(0, 0, 0, 0.82)' },
  danger: { bg: dangerColor, fg: '#fff' },
  neutral: { bg: neutralColor, fg: '#fff' }
};

export const StatusChip = styled(Chip)<{ $tone: StatusTone }>`
  && {
    height: 22px;
    font-size: 11px;
    font-weight: 600;
    font-family: 'Quicksand', sans-serif;
    background: ${(p) => TONE_STYLE[p.$tone].bg};
    color: ${(p) => TONE_STYLE[p.$tone].fg};
  }
`;
